import { createMuiTheme } from "@material-ui/core/styles";

const AppTheme = {
  palette: {
    // Primary
    primary: "#447CE9", // violetBlue
    error: "#E51820",
    warning: "#FC9C0D",
    success: "#2DBD81",

    // Neutral Colors
    neutral1: "#292838",
    neutral2: "#6F6F6F",
    neutral3: "#B4B4B4",
    neutral4: "#DDDDDD",

    // Background Colors
    mainBackground: "#FFFFFF",
    background2: "#FAFAFA",
    background3: "#EDF2FD",
  },
  // Opacity properties
  hoverOpacity: "0.7",
  disabledOpacity: "0.35",
};

export const darkTheme = {
  palette: {
    // Primary
    primary: "#447CE9", // violetBlue
    error: "#E51820",
    warning: "#FC9C0D",
    success: "#2DBD81",

    // Neutral Colors
    neutral1: "#FFFFFF",
    neutral2: "#73759B",
    neutral3: "#3C3D5B",
    neutral4: "#2F3042",

    // Background Colors
    mainBackground: "#1E1D2B",
    background2: "#252736",
    background3: "#252736",
  },
  // Opacity properties
  hoverOpacity: "0.7",
  disabledOpacity: "0.35",
};

export const MUITheme = createMuiTheme({
  palette: {
    primary: {
      main: AppTheme.palette.primary,
    },
  },
});

export const MUIThemeDark = createMuiTheme({
  palette: {
    primary: {
      main: darkTheme.palette.primary,
    },
  },
});

export const xlg = "@media (min-width: 1920px)";
export const lg = "@media (min-width: 1440px)";
export const xmd = "@media (min-width: 1280px)";
export const md = "@media (min-width: 1024px)";
export const sm = "@media (min-width: 768px)";
export const ssm = "@media (min-width: 600px)";

export const isMobile = matchMedia("(max-width: 767px)").matches;

export default AppTheme;
